import Verify from '../components/presentations/verify'

const VerifyContainer = () => <Verify />

export default VerifyContainer
